/* src/app/private/components/email-config/delete-email-config/delete-email-config.component.scss */
/*# sourceMappingURL=delete-email-config.component.css.map */
